import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const UniversalImporterTrainingCoursesPage = () => {
  const {
    company,
    access: { locale },
  } = useCurrentSession()

  return (
    <ResponsivePage.Body authorized loading={false} error={null} showHeader={false}>
      <NuvoImporter importType="training_courses_importer" locale={locale} companyId={company.id} />
    </ResponsivePage.Body>
  )
}

export default UniversalImporterTrainingCoursesPage
